/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type UpdateUserLanguageMutationVariables = Types.Exact<{
  language: Types.Language;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', usersUpdateLanguage: { __typename?: 'UpdateUserResponse', success?: boolean | null } };

export type UpdateUserCurrencyMutationVariables = Types.Exact<{
  currency: Types.CurrencyCode;
}>;


export type UpdateUserCurrencyMutation = { __typename?: 'Mutation', usersUpdateCurrency: { __typename?: 'UpdateUserResponse', success?: boolean | null } };



export const UpdateUserLanguageDocument = /*#__PURE__*/ `
    mutation updateUserLanguage($language: Language!) {
  usersUpdateLanguage(language: $language) {
    success
  }
}
    `;

export const useUpdateUserLanguageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>(
      {
    mutationKey: ['updateUserLanguage'],
    mutationFn: (variables?: UpdateUserLanguageMutationVariables) => fetcher<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useUpdateUserLanguageMutation.getKey = () => ['updateUserLanguage'];


useUpdateUserLanguageMutation.fetcher = (variables: UpdateUserLanguageMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, variables, options, fetchOptions);

export const UpdateUserCurrencyDocument = /*#__PURE__*/ `
    mutation updateUserCurrency($currency: CurrencyCode!) {
  usersUpdateCurrency(currency: $currency) {
    success
  }
}
    `;

export const useUpdateUserCurrencyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserCurrencyMutation, TError, UpdateUserCurrencyMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<UpdateUserCurrencyMutation, TError, UpdateUserCurrencyMutationVariables, TContext>(
      {
    mutationKey: ['updateUserCurrency'],
    mutationFn: (variables?: UpdateUserCurrencyMutationVariables) => fetcher<UpdateUserCurrencyMutation, UpdateUserCurrencyMutationVariables>(UpdateUserCurrencyDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useUpdateUserCurrencyMutation.getKey = () => ['updateUserCurrency'];


useUpdateUserCurrencyMutation.fetcher = (variables: UpdateUserCurrencyMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UpdateUserCurrencyMutation, UpdateUserCurrencyMutationVariables>(UpdateUserCurrencyDocument, variables, options, fetchOptions);
